import React from 'react';
import ReactScene from 'react-scene';

import spritesHelper from '../../lib/spritesHelper';
import { loadTextures, clearTextures } from '../../lib/loadTextures';
import createSprite from '../../lib/createSprite';
import Utils from '../../lib/utils';
import Scene from '../views/Scene.jsx';

import GuillotineAnimations from '../../animations/guillotine';

// Scene data
import TitrisationObjects from '../../objects/titrisation';

// import StartFrame from '../frames/_common/StartFrame.jsx';

// Frames
// import Title from '../frames/B-Titrisation/1-Title');
// import Banker from '../frames/B-Titrisation/2-Banker');
import Painters from '../frames/B-Titrisation/3-Painters.jsx';
import Stamper from '../frames/B-Titrisation/4-Stamper.jsx';
import Painter from '../frames/B-Titrisation/5-Painter.jsx';

import SlotMachineBig from '../frames/C-TooBig/2-SlotMachineBig.jsx';

// import PipeFlow from '../frames/B-Titrisation/5-PipeFlow');
// import BucketFullFrame from '../frames/B-Titrisation/6-BucketFullFrame');
// import EndFrame from '../frames/B-Titrisation/7-EndFrame');
// import PipesFrame from '../frames/B-Titrisation/2-PipesFrame.jsx';

// DAVE
import Family from '../frames/A-Remuneration/3-FamilyPump.jsx';
import Tom from '../frames/A-Remuneration/4-ManPump.jsx';
import Dave from '../frames/A-Remuneration/5-BaldGuyPump.jsx';

// import Machine from '../frames/B-Titrisation/3-Machine.jsx';

import PipeFlow from '../frames/D-Regulation/2-PipeFlow.jsx';
import BucketFullFrame from '../frames/D-Regulation/3-BucketFullFrame.jsx';

var Titrisation = React.createClass({

    propTypes: {
        name: React.PropTypes.string,
        width: React.PropTypes.number,
        height: React.PropTypes.number,

        frameWidth: React.PropTypes.number,
        frameHeight: React.PropTypes.number,

        storiesContainer: React.PropTypes.object,

        mouseDown: React.PropTypes.bool,
        mouseMove: React.PropTypes.bool,
        mouseClientX: React.PropTypes.number,
        mouseClientY: React.PropTypes.number,
        mouseWheelX: React.PropTypes.number,
        mouseWheelY: React.PropTypes.number,
    },

    contextTypes: {
        intensity: React.PropTypes.number,
    },

    getDefaultProps: function()
    {
        return {
            framesClasses: [Dave, SlotMachineBig, Painters, PipeFlow, BucketFullFrame],
            framesRenderExceptions: {
                // 4: [5],
                // 5: [4],
            },
            framesTransitions: {
                // 4: true
            }
        };
    },

    sprites: null,
    mainTimeline: null,
    guillotineTimeline: null,

    getInitialState: function()
    {
        return {
            objectsWithTextures: null,
            mainContainer: null,
            loadedProgress: 0
        };
    },

    render: function()
    {
        var props = this.props;
        var state = this.state;
        var context = this.context;

        return (
            <Scene
                intensity={context.intensity}
                mainContainer={state.mainContainer}
                objectsWithTextures={state.objectsWithTextures}
                loadedProgress={state.loadedProgress}
                {...props}
            />
        );
    },

    /*
     * React life cycle
     */

    componentWillReceiveProps: function(nextProps, nextContext)
    {

    },

    componentDidMount: function()
    {
        this.mainTimeline = new TimelineMax({
            paused: true
        });
    },

    componentWillUnmount: function()
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.pause();
            this.mainTimeline.kill();
            this.mainTimeline = null;
        }
    },

    /*
     * Scene life cycle
     */

    load: function(e)
    {
        var done = e.async();

        var onTexturesLoaded = _.bind(function(objectsWithTextures)
        {
            this.setState({
                objectsWithTextures: objectsWithTextures
            }, done)
        }, this);

        clearTextures(Object.keys(TitrisationObjects));

        loadTextures(TitrisationObjects, this.onTextureLoaded)
            .then(onTexturesLoaded);
    },

    build: function(e)
    {
        var mainContainer = new PIXI.Container();
        this.props.storiesContainer.addChild(mainContainer);
        this.sprites = {};

        this.setState({
            mainContainer: mainContainer
        }, function(){
            // this.buildObjects();
            // this.animateObjects();
            // this.updateIntensity(this.context.intensity);
        });
    },

    resize: function(e)
    {

    },

    mute: function(e)
    {

    },

    unmute: function(e)
    {

    },

    play: function(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.play();
        }
    },

    pause: function(e)
    {
        if (this.mainTimeline)
        {
            this.mainTimeline.pause();
        }
    },

    end: function(e)
    {

    },

    destroy: function(e)
    {

    },

    /*
     * Methods
     */

    buildObjects: function()
    {

    },

    animateObjects: function()
    {
    },

    updateIntensity: function(prevIntensity)
    {
    },

    /*
     * Event handlers
     */

    onTextureLoaded: function(data)
    {
        this.setState({
            loadedProgress: data.progress
        });
    }
});

module.exports = ReactScene.createScene(Titrisation);



// WEBPACK FOOTER //
// ./js/components/scenes/B-Titrisation.jsx